import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface GwSearchConditionState {
  gwCompanyName: string;
  gwCompanyNameKana: string;
  contractServiceCode: number;
  contractStoppedFlag: number;
  connectionEnvBeforeApprovalFlag: number;
  impleConfirmationBeforeApprovalFlag: number;
  priorPayoutIpidRuleUnsetFlag: number;
  timestamp: number;
}

const initialState = {} as GwSearchConditionState;

const searchConditionSlice = createSlice({
  name: "gws",
  initialState,
  reducers: {
    createSearchCondition: (
      state,
      action: PayloadAction<GwSearchConditionState>
    ) => {
      const {
        gwCompanyName: companyName,
        gwCompanyNameKana: companyNameKana,
        contractServiceCode: serviceName,
        contractStoppedFlag: contractStatus,
        connectionEnvBeforeApprovalFlag: connection,
        impleConfirmationBeforeApprovalFlag: implement,
        priorPayoutIpidRuleUnsetFlag: ipId,
        timestamp,
      } = action.payload;
      state.gwCompanyName = companyName;
      state.gwCompanyNameKana = companyNameKana;
      state.contractServiceCode = serviceName;
      state.contractStoppedFlag = contractStatus;
      state.connectionEnvBeforeApprovalFlag = connection;
      state.impleConfirmationBeforeApprovalFlag = implement;
      state.priorPayoutIpidRuleUnsetFlag = ipId;
      state.timestamp = timestamp;
    },
  },
});

export const { createSearchCondition } = searchConditionSlice.actions;

export default searchConditionSlice.reducer;
